export default "__VITE_ASSET__CerSr9vS__"